// extracted by mini-css-extract-plugin
export var chevron = "_ma-4";
export var chevronExpanded = "_ma-5";
export var row = "_ma-0";
export var rowBody = "_ma-6";
export var rowDescription = "_ma-7";
export var rowHeader = "_ma-1";
export var rowTitle = "_ma-2";
export var rowTitleComplete = "_ma-3";